import React from "react";

export interface TextBodyContentProps {
  message: string;
}

export function TextBodyContent({ message }: TextBodyContentProps) {
  return (
    <div className="text-template__container">
      <p className="text-template__message">{message}</p>
    </div>
  );
}
